export const socialSharingLabels = {
    "en": {
        "headingText": "Share post:",
        "headingTextForArticle": "Share",
        
    },
    "fr": {
        "headingText": "Partager l’article:",
        "headingTextForArticle": "Partager",
    },
    "es": {
        "headingText": "Compartir publicación:",
        "headingTextForArticle": "Compartir",
    }

}
